
    import '/Users/lijixiang/Work/power-design/site/docs/contribute/index.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/contribute/index.md?type=demo')
};